import { CSSProperties, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loadFont, transform } from "@iddataweb/idw-common-ui/utils";
import { useDeviceDetector } from "@hooks/use-device-detector";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import { getConfigurationTheme } from "@redux/selectors/verification-configuration-selectors";
import { Logger } from "@utils/logger";
import { AppVersion } from "../app-version/app-version";
import { BrowserWarningMessage } from "../browser-warning-message/browser-warning-message";
import { HeaderContainer } from "../header/header-container";
import { FooterContainer } from "../footer/footer-container";
import { MainContainer } from "../main/main-container";
import styles from "./content-container.less";

export const ContentContainer = () => {
    const deviceInfo = useDeviceDetector();
    const theme = useSelector(getConfigurationTheme);
    const content = useSelector(getLanguageContent);

    const [state, setState] = useState({
        browserWarningMessage: null,
        showBrowserWarningMessage: false
    });

    useEffect(() => {
        if (theme?.cssStyle) {
            const existingStyle = document.getElementById(`dcui-user-supplied-custom-css`);

            if (!existingStyle) {
                const output = transform(theme?.cssStyle, `#dcui-root-html`, '', false);
                const style = document.createElement('style');
                style.setAttribute("id", `dcui-user-supplied-custom-css`);
                style.setAttribute("type", "text/css");
                style.appendChild(document.createTextNode(output));
                document.head.appendChild(style);
            }
        }
    }, [theme?.cssStyle]);


    useEffect(() => {
        if (theme?.general?.font) {
            loadFont(theme.general.font, "axn_font");
        }
    }, [theme?.general?.font]);

    useEffect(() => {
        Logger.info('[AcuantCameraEffects] Check browser compatibility');
        Logger.info(
            `[AcuantCameraEffects] Check browser compatibility for device ${deviceInfo?.os?.name} and browser: ${deviceInfo?.browser?.name}`
        );

        const operatingSystem = (deviceInfo?.os?.name || "").toLowerCase();
        const browserName = (deviceInfo?.browser?.name || "").toLowerCase();
        let browserWarningMessage;

        // this means its a desktop
        if (typeof deviceInfo?.device?.type === "undefined") {
            if (operatingSystem.includes('mac') && !browserName.includes("safari")) {
                Logger.info('[AcuantCameraEffects] Show warning for desktopSafariBrowserWarningText');
                browserWarningMessage = content.acuant.desktopSafariBrowserWarningText;
            }
            if (operatingSystem.includes('windows') && !browserName.includes("chrome")) {
                Logger.info('[AcuantCameraEffects]  Show warning for desktopChromeBrowserWarningText');
                browserWarningMessage = content.acuant.desktopChromeBrowserWarningText;
            }
        } else if (["mobile", "tablet"].includes(deviceInfo?.device?.type)) {
            if (operatingSystem.includes('ios') && !browserName.includes("safari")) {
                Logger.info('[AcuantCameraEffects] Show warning for iosSafariBrowserWarningText');
                browserWarningMessage = content.acuant.iosSafariBrowserWarningText;
            } else if (operatingSystem.includes('android') && !browserName.includes("chrome")) {
                Logger.info('[AcuantCameraEffects]  Show warning for androidChromeBrowserWarningText');
                browserWarningMessage = content.acuant.androidChromeBrowserWarningText;
            }
        }

        if (browserWarningMessage) {
            setState({ browserWarningMessage: browserWarningMessage, showBrowserWarningMessage: true });
            setTimeout(() => {
                setState({ browserWarningMessage: null, showBrowserWarningMessage: false });
            }, 5000);
        }
    }, [deviceInfo]);

    const contentContainerStyle: CSSProperties = {
        fontFamily: theme.general?.font
    };

    return (
        <div id={"content-container"} className={styles.contentContainer} style={contentContainerStyle}>
            {state.showBrowserWarningMessage && state.browserWarningMessage && (
                <BrowserWarningMessage message={state.browserWarningMessage} />
            )}
            <AppVersion />
            <HeaderContainer />
            <MainContainer />
            <FooterContainer />
        </div>
    );
};